// daringfireball.net/2010/07/improved_regex_for_matching_urls
//
// modifed to
// allow ftp urls doesn't handle all our cases, but is good enough for now

/* eslint-disable no-useless-escape */
// I'm not messing with this regex, even a little bit.
const linkRegex = /\b((?:ftp|https?:\/\/|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi;
/* eslint-enable no-useless-escape */

// I'm exporting an object instead of individual functions for backward
// compatibility. This file used to be CoffeeScript
const utils = {
    getCrossOriginValue: function(url) {
        if (url.indexOf('data:image') === 0) {
            return void 0;
        }
        if (url.indexOf('Policy=') !== -1) {
            return 'Anonymous';
        }
        return 'use-credentials';
    },
    ifSpace: function(fn) {
        return function(e) {
            if (e.keyCode === 32) {
                return fn(e);
            }
        };
    },
    linkRegex,
};

// :'( Trying to maintain backward compatibility without upsetting eslint
export default utils;
export { linkRegex };
export function capitalize(string) {
    return string[0].toUpperCase() + string.slice(1);
}



// WEBPACK FOOTER //
// ./src/utils/index.js